/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "CashDrawerDetails": {
                "fields": {
                  "shiftId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientEventId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SuperPosMetadata": {
                "fields": {
                  "modeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AppFeeAllocation": {
                "fields": {
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CashDrawerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SuperPosMetadata && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AppFeeAllocation) {
	$root.addJSON(jsonData);
}

/**
 * --
 * @desc Details about the cash drawer provided by clients at the time of the payment or refund.
 * --
 *
 * SOURCE CashDrawerDetails @ squareup/pago/external/external_api_common.proto at 16:1
 */
export const CashDrawerDetails = $root.lookupType('squareup.connect.v2.CashDrawerDetails');
fixType(CashDrawerDetails);
Builder.createAndAttachToType(CashDrawerDetails);
/**
 * Metadata related to a SuperPOS Payment/Refund that is initiated with SuperPOS app.
 *
 * SOURCE SuperPosMetadata @ squareup/pago/external/external_api_common.proto at 30:1
 */
export const SuperPosMetadata = $root.lookupType('squareup.connect.v2.SuperPosMetadata');
fixType(SuperPosMetadata);
Builder.createAndAttachToType(SuperPosMetadata);
/**
 * @desc Details pertaining to the allocation of the application fee.
 *
 * SOURCE AppFeeAllocation @ squareup/pago/external/external_api_common.proto at 41:1
 */
export const AppFeeAllocation = $root.lookupType('squareup.connect.v2.AppFeeAllocation');
fixType(AppFeeAllocation);
Builder.createAndAttachToType(AppFeeAllocation);
